// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__blMXY","title":"styles_title__aYF_A","subtitle":"styles_subtitle__jxmYv","listWrapper":"styles_listWrapper___L0d6"};